import _ from "lodash";
import i18next from "src/i18n/config";
import { useSelector } from "src/store";

import { selectGroups } from "@dashboard/groups/store/selectors";
import { Box } from "@mui/material";
import { withMetaDescription } from "@navigation/utils/withMetaDescription";

import { PageContainer } from "../shared/components/PageContainer";

import { MembersRolesModal } from "./components/MembersRolesModal/MembersRolesModal";
import { MembersTable } from "./components/MemberTable";
import { PendingInvitationsPanel } from "./components/PendingInvitationsPanel/PendingInvitationsPanel";
import { useWorkspacePageAccess } from "./hooks/useWorkspacePageAccess";
import { WorkspaceMember } from "./types";

function countPending(members: WorkspaceMember[]) {
    return members.filter((member) => member.status === "Pending").length;
}

function countPendingGroupInvitations(groups: API.Group[]) {
    const pending = groups.flatMap((group) => group.members).filter((member) => member.status === "Pending");
    return _.uniqBy(pending, "email").length;
}

function WorkspaceMembersPage() {
    const { workspace } = useWorkspacePageAccess();
    const groups = useSelector(selectGroups);

    return (
        <PageContainer fullWidth={false}>
            {workspace ? (
                <Box>
                    <MembersRolesModal />
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
                        <PendingInvitationsPanel
                            workspacePendingCount={countPending(workspace.members)}
                            groupPendingCount={countPendingGroupInvitations(groups)}
                        />
                        <MembersTable />
                    </Box>
                </Box>
            ) : null}
        </PageContainer>
    );
}

export default withMetaDescription(WorkspaceMembersPage, {
    title: i18next.t("pages:workspacePage.pages.members.metaTitle"),
    description: i18next.t("pages:workspacePage.pages.members.metaDescription"),
});
